import React, { useState } from 'react';

interface CarFormProps {
  userId: number;
  car?: any; // Add car prop for editing
  onSuccess: () => void;
  onCancel: () => void;
}

const CarForm: React.FC<CarFormProps> = ({ userId, car, onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    make: car?.make || '',
    model: car?.model || '',
    year: car?.year || new Date().getFullYear().toString(),
    current_mileage: car?.current_mileage || '',
    photo_url: car?.photo_url || ''
  });
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const data = new FormData();
      data.append('user_id', userId.toString());
      data.append('make', formData.make);
      data.append('model', formData.model);
      data.append('year', formData.year);
      data.append('current_mileage', formData.current_mileage);
      if (car?.id) data.append('id', car.id.toString());
      if (selectedFile) {
        data.append('photo', selectedFile);
      } else {
        data.append('photo_url', formData.photo_url);
      }

      // Usar ruta absoluta para evitar errores de conexión según dónde esté montada la app
      const response = await fetch('backend/api/cars.php', {
        method: 'POST', 
        body: data,
      });
      const result = await response.json();
      if (!result.error) {
        onSuccess();
      } else {
        alert(result.error);
      }
    } catch (error) {
      console.error(error);
      alert("Error de conexión al servidor");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async () => {
    if (!car?.id) return;
    if (window.confirm(`¿Estás seguro de eliminar el ${car.make} ${car.model}? Esta acción no se puede deshacer.`)) {
      try {
        const response = await fetch(`backend/api/cars.php?id=${car.id}`, {
          method: 'DELETE'
        });
        const result = await response.json();
        if (!result.error) {
          onSuccess();
        } else {
          alert(result.error);
        }
      } catch (error) {
        alert("Error al eliminar vehículo");
      }
    }
  };

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>{car ? 'Editar Vehículo' : 'Agregar Nuevo Vehículo'}</h2>
        {car && (
          <button 
            type="button" 
            onClick={handleDelete}
            style={{ background: 'transparent', border: '1px solid #ef4444', color: '#ef4444', padding: '0.3rem 0.6rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.7rem' }}
          >BORRAR AUTO</button>
        )}
      </div>
      <form onSubmit={handleSubmit} style={{ marginTop: '1.5rem' }}>
        <div className="input-group">
          <label>Marca</label>
          <input 
            type="text" 
            placeholder="Ej: Toyota, Ford..." 
            value={formData.make}
            onChange={e => setFormData({...formData, make: e.target.value})}
            required 
          />
        </div>
        <div className="input-group">
          <label>Modelo</label>
          <input 
            type="text" 
            placeholder="Ej: Corolla, Fiesta..." 
            value={formData.model}
            onChange={e => setFormData({...formData, model: e.target.value})}
            required 
          />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
          <div className="input-group">
            <label>Año</label>
            <input 
              type="number" 
              value={formData.year}
              onChange={e => setFormData({...formData, year: e.target.value})}
              required 
            />
          </div>
          <div className="input-group">
            <label>KM Actual</label>
            <input 
              type="number" 
              placeholder="0" 
              value={formData.current_mileage}
              onChange={e => setFormData({...formData, current_mileage: e.target.value})}
              required 
            />
          </div>
        </div>
        <div className="input-group">
          <label>Subir Foto del Auto</label>
          <input 
            type="file" 
            accept="image/*"
            onChange={e => setSelectedFile(e.target.files ? e.target.files[0] : null)}
            style={{ padding: '0.5rem 0' }}
          />
        </div>
        <div className="input-group">
          <label>O usar URL de Foto</label>
          <input 
            type="text" 
            placeholder="https://ejemplo.com/mifoto.jpg" 
            value={formData.photo_url}
            onChange={e => setFormData({...formData, photo_url: e.target.value})}
          />
        </div>
        <div className="car-actions" style={{ marginTop: '1rem' }}>
          <button type="button" className="btn btn-outline" onClick={onCancel}>Cancelar</button>
          <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
            {isSubmitting ? 'Guardando...' : 'Registrar Auto'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CarForm;
